import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqospherePrize {
  constructor(api) {
    this.api = api
  }

  getPrize = async (productid, variantid, stock) => {
    const res = await this.api.get(
      `/iqosphere/prizes/${productid}${variantid ? '/' + variantid : ''}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        params: { ...(stock && { stock: true }) },

        mock: this.api.getMock(!stock ? 'getPrize' : 'getPrizeWithStocks')
      }
    )
    return res
  }

  getPrizeBySeoName = async (seoname, stock) => {
    const res = await this.api.get('/iqosphere/prizes/', {
      params: { ...(seoname && { seoname }), ...(stock && { stock: true }) },
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock(!stock ? 'getPrize' : 'getPrizeWithStocks')
    })
    return res
  }

  getPrizes = async (categoryid = '', stock) => {
    const res = await this.api.get('/iqosphere/prizes', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: {
        ...(categoryid && { categoryid }),
        ...(stock && { stock: true })
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock(!stock ? 'getPrizes' : 'getPrizesWithStocks')
    })
    return res
  }

  getPrizesCampaign = async (campaigncode = '', stock) => {
    const res = await this.api.get('/iqosphere/prizes', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: {
        ...(campaigncode && { campaigncode }),
        ...(stock && { stock: true })
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock(!stock ? 'getPrizes' : 'getPrizesWithStocks')
    })
    return res
  }

  getOrderPrize = async (id, line) => {
    const res = await this.api.get(`/iqosphere/prizes/order/${id}`, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: { t: new Date().getTime(), ...(line && { isPrizeId: true }) },
      mock: this.api.getMock('getOrderPrize')
    })
    return res
  }

  confirmAddress = async (data, ignoreAddressValidation = false) => {
    const res = await this.api.post(
      `/iqosphere/prizes/confirmAddress?b=${ignoreAddressValidation}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('confirmAddress'),
        data
      }
    )
    return res
  }

  getSpinWheelStatus = async (campaignCode, missionCode) => {
    const res = await this.api.get('/iqosphere/spinwheel/status', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getSpinWheelStatus'),
      params: {
        ...(campaignCode && { campaignCode }),
        ...(missionCode && { missionCode })
      },
      useProxy: true,
      withCredentials: true
    })

    return res
  }

  spinWheel = async (campaignCode, action, mission, spinType = false) => {
    const res = await this.api.post('/iqosphere/spinwheel/spin', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('spinWheel'),
      data: {
        campaignCode,
        action,
        ...(mission && { mission }),
        ...(spinType && { spinType: 'free' })
      },
      useProxy: true,
      withCredentials: true
    })
    return res
  }

  getCampaignProgress = async campaignCode => {
    const res = await this.api.get(
      `/iqosphere/campaign/progress?campaign=${campaignCode}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getCampaignProgress'),
        useProxy: true,
        withCredentials: true
      }
    )
    return res
  }
}
